const initialState = {
  currentStep: 0,
  triggerStep: null,
  isRenewalGroup: 'Yes',
  isExit: false,
  currentUser: null,
  groupDetails: {},
  quoteID: null,
  isValidProduct: false,
  isPlanAvailable: false,
  disabledContinueText: false,
  lifeClasses: [],
  showLifeClass: false,
  skipCensus: false,
  sgqInternalUser: false,
  reloadQuotesSummaryRecords: false,
  isBackButton: false,
  sgqStateInfo: {},
  isDentalSideBarOpen: false,
  isStateDisabled: false,
  isLifeFlagModified: false,
  oldRenewalDate: null,
  sgqInternalAdminUser: true,

  steps: ['/group-details', '/census', '/medical-plans', '/dental-plans', '/vision-plans', '/review-proposal'],
  progressStepper: ['Group Details', 'Census', 'Medical', 'Dental', 'Vision', 'Review Proposal'],
  stepsTxt: ['Group Details', 'Census', 'Medical Plan', 'Dental Plan', 'Vision Plan', 'Review Proposal'],
  newSteps: [
    '/group-details',
    '/census',
    '/medical-plans',
    '/dental-plans',
    '/vision-plans',
    '/life-disability-plans',
    '/review-proposal',
  ],
  progressStepperNew: [
    'Group Details',
    'Census',
    'Medical',
    'Dental',
    'Vision',
    'Life & Disability',
    'Review Proposal',
  ],
  stepsTxtNew: [
    'Group Details',
    'Census',
    'Medical Plan',
    'Dental Plan',
    'Vision Plan',
    'Life & Disability',
    'Review Proposal',
  ],
  censusSkipSteps: [
    '/group-details',
    '/medical-plans',
    '/dental-plans',
    '/vision-plans',
    '/life-disability-plans',
    '/review-proposal',
  ],
  censusSkipStepsWithoutLD: [
    '/group-details',
    '/medical-plans',
    '/dental-plans',
    '/vision-plans',
    '/review-proposal',
  ],
  censusSkipStepper: ['Group Details & Census', 'Medical', 'Dental', 'Vision', 'Life & Disability', 'Review Proposal'],
  censusSkipStepperWithoutLD: ['Group Details & Census', 'Medical', 'Dental', 'Vision', 'Review Proposal'],
  censusSkipStepsTxt: [
    'Group Details & Census',
    'Medical Plan',
    'Dental Plan',
    'Vision Plan',
    'Life & Disability',
    'Review Proposal',
  ],
  censusSkipStepsTxtWithoutLD: [
    'Group Details & Census',
    'Medical Plan',
    'Dental Plan',
    'Vision Plan',
    'Review Proposal',
  ],
  censusSkipStepsOnExchange: ['/group-details', '/medical-plans', '/dental-plans', '/review-proposal'],
  skipCensusSections: ['Medical Plan', 'Dental Plan', 'Vision Plan'],
  skipOnExchangeNewQuoteSections: ['Vision Plan', 'Life & Disability'],
  censusSkipStepperOnExchange: ['Group Details & Census', 'Medical', 'Dental', 'Review Proposal'],
  censusSkipStepsTxtOnExchange: ['Group Details & Census', 'Medical Plan', 'Dental Plan', 'Review Proposal'],
  sgqSteps: [],
};

const sgqReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_CURRENT_STEP': {
      return { ...state, ...{ currentStep: action.data } };
    }
    case 'TRIGGER_NEXT_STEP': {
      return { ...state, ...{ triggerStep: action.data } };
    }
    case 'SET_IS_RENEWAL_GROUP': {
      return { ...state, ...{ isRenewalGroup: action.data } };
    }
    case 'SET_CURRENT_SGQ_USER': {
      return { ...state, ...{ currentUser: action.data } };
    }
    case 'SET_IS_GROUP_DETAIL': {
      return { ...state, ...{ groupDetails: action.data } };
    }
    case 'SET_REVIEW_PROPOSAL_QUOTE_ID': {
      return { ...state, ...{ quoteID: action.data } };
    }
    case 'SET_IS_VALID_PRODUCT': {
      return { ...state, ...{ isValidProduct: action.data } };
    }
    case 'SET_IS_PLANS_AVAILABLE': {
      return { ...state, ...{ isPlanAvailable: action.data } };
    }
    case 'SET_IS_EXIT': {
      return { ...state, ...{ isExit: action.data } };
    }
    case 'SET_IS_DISABLED_CONTINUE_TEXT': {
      return { ...state, ...{ disabledContinueText: action.data } };
    }
    case 'SET_SHOW_LIFE_CLASS': {
      return { ...state, ...{ showLifeClass: action.data } };
    }
    case 'SET_LIFE_CLASSES': {
      return { ...state, ...{ lifeClasses: JSON.parse(JSON.stringify(action.data)) } };
    }
    case 'SET_SKIP_CENSUS': {
      return { ...state, ...{ skipCensus: action.data } };
    }
    case 'SET_SGQ_INTERNAL_USER': {
      return { ...state, ...{ sgqInternalUser: action.data } };
    }
    case 'SET_SGQ_INTERNAL_ADMIN_USER': {
      return { ...state, ...{ sgqInternalAdminUser: action.data } };
    }
    case 'SET_SGQ_STEPS': {
      return { ...state, ...{ sgqSteps: action.data } };
    }
    case 'SUBMIT_DENTAL_OVERRIDE_PROPOSAL_SUCCESS': {
      return { ...state, ...{ reloadQuotesSummaryRecords: action.data } };
    }
    case 'SET_IS_BACK_BUTTON_CLICKED': {
      return { ...state, ...{ isBackButton: action.data } };
    }
    case 'SET_SGQ_STATE_INFO': {
      return { ...state, ...{ sgqStateInfo: action.data } };
    }
    case 'SET_IS_SIDE_BAR_OPEN': {
      return { ...state, ...{ isDentalSideBarOpen: action.data } };
    }
    case 'SET_IS_STATE_DISABLED': {
      return { ...state, ...{ isStateDisabled: action.data } };
    }
    case 'SET_IS_LIFE_FLAG_MODIFIED': {
      return { ...state, ...{ isLifeFlagModified: action.data } };
    }
    case 'SET_OLD_RENEWAL_DATE': {
      return { ...state, ...{ oldRenewalDate: action.data } };
    }
    default: {
      return state;
    }
  }
};

export default sgqReducers;
